import Vue from 'vue'
import SurveyPage from '../vue/pages/Survey.vue'

export default {
	init() {
		new Vue({
			components: { SurveyPage },
			el: '.survey-form',
		})
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
